import React from 'react';
import { connect } from 'react-redux';
import { some, identity, isEmpty, values } from 'lodash/fp';
import * as assignmentsSelectors from 'selectors/learn/assignments';
import * as contentsSelectors from 'selectors/learn/contents';
import * as topicsSelectors from 'selectors/learn/topics';
import { hasGlobalFeature } from 'selectors';
import { usePageTitle } from 'components/shared/PageTitle';
import AdditionalContent from './AdditionalContent';
import FeaturedContent from './FeaturedContent';
import IncompleteAssignments from './IncompleteAssignments';
import Topics from './Topics';
import NoContent from './NoContent';

const MyContent = props => {
  usePageTitle(t('learn.sidebar.my_learning_content'));
  return (
    <div>
      {props.hasIncompleteAssignments && <IncompleteAssignments />}
      {props.hasFeaturedContents && <FeaturedContent />}
      {props.hasTopics && <Topics />}
      {props.hasAdditionalContent && <AdditionalContent />}
      {!props.hasAnyContent && <NoContent />}
    </div>
  );
};

const mapStateToProps = state => {
  const sectionsConditions = {
    hasIncompleteAssignments:
      !hasGlobalFeature(state, 'hide_my_assignments') &&
      assignmentsSelectors.hasIncompleteAssignments(state),
    hasTopics: topicsSelectors.hasTopics(state),
    hasAdditionalContent: !isEmpty(
      contentsSelectors.additionalContentsSelector(state),
    ),
    hasFeaturedContents: contentsSelectors.hasFeaturedContents(state),
  };
  return {
    ...sectionsConditions,
    hasAnyContent: some(identity, values(sectionsConditions)),
  };
};

export default connect(mapStateToProps)(MyContent);
